export default {
  home: {
    indicatePreferred: 'Tercih ettiğiniz biniş noktasını haritada işaretleyin.',
    searchAddress:
      'Tercih ettiğiniz biniş noktasını arama çubuğundan aratabilir ya da ev ikonunu istediğiniz noktaya sürükleyerek seçebilirsiniz.',
    setLater: 'Daha sonra kaydet',
  },
  kvkk: {
    approveDocument: 'Kullanıcı sözleşmesini kabul ediyorum',
  },
  hideCompleted: 'Tamamlanananları Gösterme',
  wallet: {
    title: 'Cüzdanım',
    balance: 'Bakiye',
    addMoney: 'Para Ekle',
    transactions: 'İşlemler',
    noTransactions: 'Henüz işlem yok',
    topUpTitle: 'Cüzdana Yükle',
    enterAmount: 'Yüklemek istediğiniz tutarı girin.',
    continueSecurePayment: 'Ardından tercih ettiğiniz ödeme yöntemiyle güvenli ödemeye devam edin.',
    total: 'Tahsil edilecek toplam',
    totalAfterFee: 'Ödeme sağlayıcı komisyonu eklendikten sonra tahsil edilecek toplam',
    currentBalance: 'Mevcut Bakiye',
    cancel: 'İptal',
    continueToPayment: 'Ödemeye Devam Et',
    back: 'Geri',
    pay: 'Öde',
    processing: 'İşleniyor...',
    paymentSuccessTitle: 'Ödeme Başarılı',
    paymentSuccessMessage: 'Cüzdanınıza başarıyla yükleme yapıldı.',
    paymentFailedTitle: 'Ödeme Başarısız',
    paymentFailedMessage: 'Ödemenizde bir sorun oluştu. Lütfen tekrar deneyin.',
    done: 'Tamam',
    tryAgain: 'Tekrar Dene',
    serviceFeeCharged: '{amount} İşlem ücreti tahsil edildi.',
    monthlyPass: 'Monthly Pass',
    unlimitedRides: 'Tüm rotalarda sınırsız yolculuk',
    pricePerMonth: '{price}/ ay',
    buy: 'Satın Al',
    buyMonthlyPass: 'Monthly Pass Satın Al',
    validUntilEndOfMonth: 'İçinde bulunulan takvim ayının sonuna kadar geçerlidir.',
    processingFee: 'İşlem ücreti',
    totalToBePaid: 'Ödenecek toplam',
    monthlyPassActive: 'Monthly Pass aktif',
    expiresInDays: '{count} gün içinde sona erer',
    monthlyPassActivated: 'Monthly Pass aktifleştirildi',
    walletTopUp: 'Cüzdan Yükleme',
    walletTopUpByAdmin: 'Yönetici Tarafından Cüzdan Yükleme',
    paymentFromMethod: '{amount} {method}',
    paymentFromWallet: '{amount} Cüzdan bakiyesinden',
    paymentSourceList: '{first}, {second}',
    monthListSeparator: ', ',
    monthlyPassForMonth: '{month} Pass',
    monthlyPassForMonths: '{months} Pass',
    serviceFeeChargedWithAmount: '{amount} + {fee} işlem ücreti tahsil edildi',
    passSuccessMessage: 'Monthly Pass aboneliğiniz aktif.',
    coveredByMonthlyPass: 'Monthly Pass kapsamında',
    selectMonthDescription: 'Pass satın almak istediğiniz ay(lar)ı seçin',
    noAvailablePasses: 'Şu anda satın alınabilecek pass bulunmuyor.',
    passValidUntil: '{date} tarihine kadar geçerli',
    passValidRange: 'Geçerli {date}',
    validFromTo: 'Geçerlilik {from} - {to}.',
    passExpiresOn: 'Son geçerlilik tarihi: {date}',
    totalAmount: 'Toplam Tutar',
    walletBalanceLabel: 'Cüzdan Bakiyesi',
    useWalletBalance: 'Cüzdan bakiyesini kullan',
    remaining: 'Kalan tutar',
    buyOtherPass: 'Başka pass al',
    confirm: {
      title: 'Ödemeyi Onayla',
      message:
        '{totalAmount} tutarındaki monthly pass için {walletAmount} cüzdan bakiyenizi kullanmak ve kalan {remainingAmount} tutarı kredi kartınızla ödemek istiyor musunuz?',
      messageWalletOnly:
        '{totalAmount} tutarındaki monthly pass için {walletAmount} cüzdan bakiyenizi kullanmak istiyor musunuz?',
      messageCardOnly: '{totalAmount} tutarındaki monthly pass için kredi kartınızla ödeme yapmak istiyor musunuz?',
      confirmButton: 'Onayla ve Öde',
    },
    errors: {
      passAlreadyExists: 'Seçilen ay için zaten bir pass’iniz var.',
      purchaseInProgress: 'Önceki satın alımınız hâlâ işleniyor. Lütfen birkaç saniye sonra tekrar deneyin.',
      purchaseCompleted: 'Satın alımınız tamamlandı, kısa süre içinde aktifleşecek.',
      insufficientBalance: 'Cüzdan bakiyeniz bu satın alım için yeterli değil.',
      notEnabled: 'Monthly Pass şirketiniz için kullanılamıyor.',
      invalidData: 'Seçilen aylar geçersiz. Lütfen seçiminizi gözden geçirin.',
    },
  },
  routeSearch: {
    title: 'Rota Ara',
    filters: {
      suggested: 'Önerilen',
      allRoutes: 'Tüm Rotalar',
      commute: 'Sabit',
      loop: 'Ring',
      overtime: 'Fazla Mesai',
      nearDemand: 'Dinamik',
    },
    toDestination: 'yönüne',
    dynamicBadge: 'Dinamik',
    reservationsCloseIn: 'Rezervasyonlar kapanıyor',
    showZonesInfo: 'Bölgeleri göster',
    hideZonesInfo: 'Bölgeleri gizle',
    hideRoutes: 'Rotaları Gizle',
    showRoutes: 'Rotaları Göster',
    routesThroughStation: '{station} durağından geçen rotalar',
    routesPassingHere: 'Buradan geçen rotalar',
    noRoutesAtStop: 'Bu duraktan geçen rota yok.',
    emptyState:
      'Seçilen tarihte bu konumdan geçen rota yok. Haritayı başka bir bölgeye kaydırın veya başka bir tarih deneyin.',
    campus: 'Kampüs',
    home: 'Ev',
    myLocation: 'Konumum',
    addHomeAddressMessage: 'Ev adresinizin yakınındaki rotaları göstermek için ev adresinizi ekleyin.',
    addNow: 'Şimdi',
    later: 'Sonra',
    locationPermissionMessage:
      'Yakınınızdaki rotaları görebilmek için tarayıcı ayarlarınızdan konum erişimine izin verin.',
    ok: 'Tamam',
    routePinned: 'Rota Sabitlendi',
    routePinnedMessage:
      'Rota kolay erişim için sabitlendi. Yaklaşma ve varış bildirimleri almak için lütfen bu rotaya rezervasyon yapın.',
    nearDemandGroupPinned: 'Talep Yakınındaki Grup Sabitlendi',
    nearDemandGroupPinnedMessage: 'Kolay erişim için talep yakınındaki grup sabitlendi.',
    requestFailed: 'İstek Başarısız',
    cannotUnpin: 'Bu rotanın sabitlemesi kaldırılamıyor.',
    genericError: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    selectPickupInside: '{zone} içinde biniş noktası seçin',
    selectDropoffInside: '{zone} içinde iniş noktası seçin, {time}',
    tbd: 'TBD',
    waitlist: 'Bekleme Listesi',
    waitlistMessage: 'Bekleme listesine eklendiniz. Sıranız: {order}.',
    demandSuccess: 'Talebiniz başarıyla gönderildi.',
    multiDemandSuccess: 'Çok günlü talebiniz başarıyla gönderildi.',
    reservationSuccess: 'Rezervasyonunuz başarıyla oluşturuldu.',
    subscribeSuccess: 'Aboneliğiniz başarıyla oluşturuldu.',
    actionSuccess: 'İşlem başarıyla tamamlandı.',
    // A subscription is per departure time and repeats on every day the
    // route runs; it has no date (VSER-15349).
    pinSheet: {
      pinRoute: 'Bu rotayı sabitle',
      notifications: 'Yaklaşma ve varış bildirimlerini al',
      thisTripOnly: 'Yalnızca {time} seferi',
      thisTripOnlyNoTime: 'Yalnızca bu sefer saati',
      allTrips: 'Tüm sefer saatleri',
      hint: 'Seçilen seferler, rotanın çalıştığı her gün seyahatlerinize eklenir.',
      cancel: 'İptal',
      save: 'Kaydet',
    },
  },
  bringingBike: 'Bisiklet getiriyorum',
  bikes: 'Bisikletler',
  usingWheelchair: 'Tekerlekli sandalye kullanıyorum',
  wheelchairs: 'Tekerlekli sandalyeler',
  bikeCapacityFull: 'Bisiklet kapasitesi dolu',
  remainingBikeCapacity: 'Kalan bisiklet kapasitesi',
  wheelchairCapacityFull: 'Tekerlekli sandalye kapasitesi dolu',
  routeDetail: {
    activeOn: 'Aktif olduğu günler',
    vehicleDriver: 'Araç, Sürücü',
    weekdays: 'Hafta içi',
    everyDay: 'Her gün',
    days: {
      mon: 'Pzt',
      tue: 'Sal',
      wed: 'Çar',
      thu: 'Per',
      fri: 'Cum',
      sat: 'Cmt',
      sun: 'Paz',
    },
    departFrom: 'Kalkış noktası',
    arriveAt: 'Varış noktası',
    departureTime: 'Kalkış Saati',
    etd: 'ETD',
    eta: 'ETA',
    tbd: 'Belirlenecek',
    addressPlaceholder: 'Adres yazın veya haritada konum seçin',
    addressOutsideArea: 'Adres, vurgulanan alanın içinde olmalıdır',
    serviceAreaBanner:
      'Konum iğnenizi yerleştirmek için yeşille vurgulanan hizmet alanının içine tıklayın veya bir Park & Ride seçin. Alternatif olarak aşağıdan bir adres arayabilirsiniz.',
    multipleDayReservation: 'Çok Günlü Rezervasyon',
    fromUntil: 'Başlangıç - Bitiş',
    daysToUseShuttle: 'Servisi kullanacağım günler:',
    numberOfRiders: 'Yolcu Sayısı',
    riderCountLimitedByCapacity: 'Yolcu sayısı rota kapasitesi ile sınırlıdır',
    driver: 'Sürücü',
    vehicle: 'Araç',
    noReservationsRequired: 'Rezervasyon gerekmez',
    subscribe: 'Abone Ol',
    waitlistOpen: 'Bekleme listesi açık',
    joinWaitlist: 'Bekleme Listesine Katıl',
    boardingFarePerTrip: 'Yolculuk Ücreti',
    organizationBoardingFare: 'Kurumsal Biniş Ücreti',
    guestBoardingFare: 'Misafir Biniş Ücreti',
    freeWithMonthlyPass: '(Monthly Pass ile Ücretsiz)',
    remainingBikeCapacity: 'Kalan Bisiklet Kapasitesi',
    reservationsCloseIn: 'Rezervasyonların kapanmasına',
    seatsRemaining: 'Kalan Koltuk Sayısı',
    reserve: 'Rezerve Et',
    reservationsOpenOn: 'Rezervasyonlar {date} tarihinde açılır',
    reservationWindowClosed: 'Rezervasyon süresi doldu',
    durationHoursMinutes: '{hours} sa {minutes} dk',
    durationMinutes: '{minutes} dk',
  },
};
